import React from 'react';
import type { FC } from 'react';

import { IconSpinner } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';
import styles from './Loading.module.scss';

interface LoadingProps {
    text: string;
    size?: 'sm' | 'md';
    className?: string;
}

export const Loading: FC<LoadingProps> = ({ text, size = 'sm', className }) => (
    <div className={cx(styles.loading, styles[size], className)} role="status">
        <IconSpinner className={styles.spinner} aria-hidden="true" />
        <p>{text}</p>
    </div>
);